<div class="tile-container-skeleton" *ngIf="loadingData">
  <div fxLayoutAlign="center">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="tile-container" [ngClass]="{ hide: loadingData }">
  <div fxLayout="column">
    <div fxLayout="row" class="tile-header" [ngClass]="{ hide: loadingData }">
      Source of Traffic
    </div>
    <div fxLayout="row" fxFlex="100%" [ngClass]="{ hide: loadingData }">
      <div fxLayout="column" fxFlex="70%" id="source-legend"></div>
      <div fxLayout="column" fxFlex="30%">
        <mat-form-field appearance="outline">
          <mat-label>Creative</mat-label>
          <mat-select
            [(ngModel)]="selectedCreative"
            [ngModelOptions]="{ standalone: true }"
            (selectionChange)="changeSelectedCreative($event)"
          >
            <mat-option [value]="'All'">All</mat-option>
            <mat-option *ngFor="let c of creatives" [value]="c">
              {{ c }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="chart-container" *ngIf="!loadingData" fxLayout="row">
      <div fxLayout="column" fxFlex="45%">
        <!--non-micromoment chart-->
        <div fxLayoutAlign="center">
          <h5>Total</h5>
        </div>
<!--        <x-chartist-->
<!--          #nMMChart-->
<!--          [type]="chartType"-->
<!--          class="chart"-->
<!--          [configuration]='chartConfig'-->
<!--          [data]="nMMChartData"-->
<!--          [options]="nMMChartOpts"-->
<!--          [events]="chartEvents"-->
<!--          (initialized)="chartInitialized($event)"-->
<!--        ></x-chartist>-->
      </div>
      <div fxLayout="column" fxFlex="45%">
        <!--micromoment chart-->
        <div fxLayoutAlign="center">
          <h5>Micro-Moment</h5>
        </div>
<!--        <x-chartist-->
<!--          #mmChart-->
<!--          [type]="chartType"-->
<!--          class="chart"-->
<!--          [configuration]='chartConfig'-->
<!--          [data]="mmChartData"-->
<!--          [options]="mmChartOpts"-->
<!--          [events]="chartEvents"-->
<!--          (initialized)="chartInitialized($event)"-->
<!--        ></x-chartist>-->
      </div>
    </div>
  </div>
</div>
